import { all, takeEvery, put, call } from 'redux-saga/effects'
import { removeCacheCategoria, removeCacheEtiqueta } from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* REMOVE_CACHE_CATEGORIA() {
  try {
    const result = yield call(removeCacheCategoria)
    if (result.ok) {
      putMessage(messageType.SUCCESS, 'Cache categoría eliminado correctamente')
      yield put({
        type: actions.CACHE_ELIMINAR_CATEGORIA_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Cache categoría')
      yield put({
        type: actions.CACHE_ELIMINAR_CATEGORIA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Cache categoría')
    yield all([
      put({
        type: actions.CACHE_ELIMINAR_CATEGORIA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* REMOVE_CACHE_ETIQUETA() {
  try {
    const result = yield call(removeCacheEtiqueta)
    if (result.ok) {
      putMessage(messageType.SUCCESS, 'Cache etiqueta eliminado correctamente')
      yield put({
        type: actions.CACHE_ELIMINAR_ETIQUETA_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Cache etiqueta')
      yield put({
        type: actions.CACHE_ELIMINAR_ETIQUETA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Cache etiqueta')
    yield all([
      put({
        type: actions.CACHE_ELIMINAR_ETIQUETA_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CACHE_ELIMINAR_CATEGORIA_REQUESTED, REMOVE_CACHE_CATEGORIA),
    takeEvery(actions.CACHE_ELIMINAR_ETIQUETA_REQUESTED, REMOVE_CACHE_ETIQUETA),
  ])
}
